import { useInfiniteQuery, useQuery } from 'react-query';
import {
  InvoiceGovernmentClassificationTaxListRequest,
  InvoiceGovernmentCstListRequest,
} from './government.types';
import governmentServices from './government.services';

export const INVOICE_GOVERNMENT_CST_LIST = 'invoice/goverment/cst-list';
export const INVOICE_GOVERNMENT_CST_DETAIL = 'invoice/goverment/cst-detail';
export const INVOICE_GOVERNMENT_CLASSIFICATION_TAX_LIST =
  'invoice/goverment/classification-tax-list';
export const INVOICE_GOVERNMENT_CLASSIFICATION_TAX_DETAIL =
  'invoice/goverment/classification-tax-detail';
export const INVOICE_GOVERNMENT_PRESUMED_CODE_LIST =
  'invoice/goverment/presumed-code-list';
export const INVOICE_GOVERNMENT_PRESUMED_CODE_DETAIL =
  'invoice/goverment/presumed-code-detail';

export function useInvoiceGovermentCstList(
  params: InvoiceGovernmentCstListRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [INVOICE_GOVERNMENT_CST_LIST, { ...params }],
    queryFn: ({ pageParam }) =>
      governmentServices.cstList({ ...params, nextToken: pageParam }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled: enabled && !!params.cstType,
  });
}

export function useInvoiceGovermentCstDetail(code?: string, enabled = true) {
  return useQuery({
    queryKey: [INVOICE_GOVERNMENT_CST_DETAIL, code],
    queryFn: () => governmentServices.cstDetail(code),
    enabled: enabled && !!code,
  });
}

export function useInvoiceGovermentClassificationTaxList(
  params: InvoiceGovernmentClassificationTaxListRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [INVOICE_GOVERNMENT_CLASSIFICATION_TAX_LIST, { ...params }],
    queryFn: ({ pageParam }) =>
      governmentServices.classificationTaxList({
        ...params,
        nextToken: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled: enabled && !!params.classificationType,
  });
}

export function useInvoiceGovermentClassificationTaxDetail(
  code?: string,
  enabled = true,
) {
  return useQuery({
    queryKey: [INVOICE_GOVERNMENT_CLASSIFICATION_TAX_DETAIL, code],
    queryFn: () => governmentServices.classificationTaxDetail(code),
    enabled: enabled && !!code,
  });
}

export function useInvoiceGovermentPresumedCodeList(enabled = true) {
  return useQuery({
    queryKey: [INVOICE_GOVERNMENT_PRESUMED_CODE_LIST],
    queryFn: () => governmentServices.presumedCodeList(),
    enabled,
  });
}

export function useInvoiceGovermentPresumedCodeDetail(
  code?: string,
  enabled = true,
) {
  return useQuery({
    queryKey: [INVOICE_GOVERNMENT_PRESUMED_CODE_DETAIL, code],
    queryFn: () => governmentServices.presumedCodeDetail(code),
    enabled: enabled && !!code,
  });
}
